export const forTimes = (times: number, cb: (i: number) => void): void => {
  for (let i = 0; i < times; i++) cb(i);
};

export const mapTimes = <T>(times: number, cb: (i: number) => T): T[] => {
  const arr: T[] = [];
  forTimes(times, (i) => arr.push(cb(i)));
  return arr;
};
